import { PastActionItem } from "./PastActionItem";

export default PastActionItem;
